import {
  GroupByMode,
  ID,
  overdueSectionID,
  ReorderSectionUpdate,
  SortingMode,
  UserSettings,
} from '@griply/types';

export type BuildUpcomingReorderUserSettingsOptions = {
  updatedSections: ReorderSectionUpdate[];
};

export const buildUpcomingReorderUserSettings = ({
  updatedSections,
}: BuildUpcomingReorderUserSettingsOptions): Partial<UserSettings> | null => {
  const newOrder = updatedSections.reduce<Record<ID, ID[]>>((acc, section) => {
    if (section.id === overdueSectionID) {
      return acc;
    }
    acc[section.id] = section.taskSorting;
    return acc;
  }, {});

  if (!Object.keys(newOrder).length) {
    return null;
  }

  return {
    customTaskOrder: {
      upcoming: { [GroupByMode.UpcomingDeadline]: newOrder },
    },
    todoSortingMode: SortingMode.Custom,
    todoSorting: newOrder,
  };
};
